// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2M9J5"};